var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUgler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 198,
    viewBox: "0 0 375 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.749,
    cy: 325.077,
    rx: 278.683,
    ry: 172.077,
    fill: "#199581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9794 103.486C52.1054 106.941 60.1635 105.125 63.6768 103.785L58.5716 117.639C53.3217 111.482 43.8534 100.032 47.9794 103.486Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.785 92.5937C121.783 97.0596 113.537 97.5556 109.79 97.2454L118.546 109.134C121.877 101.76 127.788 88.1279 124.785 92.5937Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.7584,
    cy: 130.341,
    r: 39.5,
    transform: "rotate(-8.07192 91.7584 130.341)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.8142,
    cy: 124.46,
    rx: 12.5,
    ry: 12,
    transform: "rotate(-8.07192 79.8142 124.46)",
    fill: "#D4AE8B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.101,
    cy: 121.441,
    r: 12,
    transform: "rotate(-8.07192 101.101 121.441)",
    fill: "#D4AE8B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(0.990093 -0.140416 -0.140416 -0.990093 82.2895 124.109)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(0.990093 -0.140416 -0.140416 -0.990093 83.4236 121.423)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(0.990093 -0.140416 -0.140416 -0.990093 102.091 121.3)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.1094,
    cy: 132.816,
    rx: 3.5,
    ry: 5,
    transform: "rotate(-8.07192 92.1094 132.816)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.6775,
    cy: 169.646,
    rx: 2,
    ry: 5,
    transform: "rotate(-8.07192 81.6775 169.646)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.7882,
    cy: 170.214,
    rx: 2,
    ry: 5,
    transform: "rotate(-8.07192 84.7882 170.214)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.7584,
    cy: 169.793,
    rx: 2,
    ry: 5,
    transform: "rotate(-8.07192 87.7584 169.793)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 5,
    transform: "matrix(-0.990093 0.140416 0.140416 0.990093 110.531 166.564)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 5,
    transform: "matrix(-0.990093 0.140416 0.140416 0.990093 107.701 167.975)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 5,
    transform: "matrix(-0.990093 0.140416 0.140416 0.990093 104.73 168.396)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(0.990093 -0.140416 -0.140416 -0.990093 104.215 118.474)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.764 145.025C67.1596 153.243 63.1395 161.643 62.477 161.836C61.1521 162.222 53.9103 157.105 51.5147 148.887C49.119 140.668 50.143 133.141 53.8016 132.075C57.4603 131.008 62.3683 136.806 64.764 145.025Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.768 135.023C123.671 143.536 130.579 149.781 131.265 149.709C132.638 149.563 137.395 142.08 136.492 133.567C135.589 125.054 131.784 118.48 127.995 118.882C124.205 119.284 121.865 126.511 122.768 135.023Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.872 92.4107C250.875 96.8765 259.12 97.3722 262.868 97.0619L254.112 108.95C250.781 101.576 244.869 87.9449 247.872 92.4107Z",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.678 103.301C320.552 106.756 312.494 104.94 308.981 103.6L314.087 117.454C319.336 111.297 328.804 99.8458 324.678 103.301Z",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.459,
    cy: 130.378,
    r: 39.5,
    transform: "rotate(8.07 282.459 130.378)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.621,
    cy: 121.408,
    rx: 12.5,
    ry: 12,
    transform: "rotate(8.07 272.621 121.408)",
    fill: "#D4AE8B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.908,
    cy: 124.426,
    r: 12,
    transform: "rotate(8.07 293.908 124.426)",
    fill: "#D4AE8B"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(0.990097 0.140383 0.140383 -0.990097 275.096 121.759)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(0.990097 0.140383 0.140383 -0.990097 276.932 119.494)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    transform: "matrix(0.990097 0.140383 0.140383 -0.990097 294.898 124.566)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.108,
    cy: 132.853,
    rx: 3.5,
    ry: 5,
    transform: "rotate(8.07 282.108 132.853)",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.848,
    cy: 165.33,
    rx: 2,
    ry: 5,
    transform: "rotate(8.07 261.848 165.33)",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.678,
    cy: 166.742,
    rx: 2,
    ry: 5,
    transform: "rotate(8.07 264.678 166.742)",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.649,
    cy: 167.163,
    rx: 2,
    ry: 5,
    transform: "rotate(8.07 267.649 167.163)",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 5,
    transform: "matrix(-0.990097 -0.140383 -0.140383 0.990097 290.421 170.391)",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 5,
    transform: "matrix(-0.990097 -0.140383 -0.140383 0.990097 287.31 170.96)",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2,
    ry: 5,
    transform: "matrix(-0.990097 -0.140383 -0.140383 0.990097 284.34 170.539)",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(0.990097 0.140383 0.140383 -0.990097 297.724 122.442)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.447 136.978C252.463 145.538 246.266 152.489 245.576 152.491C244.196 152.493 238.662 145.564 238.646 137.004C238.63 128.443 241.706 121.498 245.517 121.491C249.328 121.483 252.43 128.417 252.447 136.978Z",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.945 143.497C309.446 151.925 314.345 159.845 315.024 159.966C316.383 160.207 323.033 154.342 324.532 145.914C326.031 137.485 324.205 130.112 320.453 129.445C316.701 128.777 312.444 135.069 310.945 143.497Z",
    fill: "#733904"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.171 52.9085C158.449 57.6618 168.233 56.8696 172.59 55.8793L164.272 71.3273C159.122 63.2072 149.893 48.1553 154.171 52.9085Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.834 52.9085C213.556 57.6618 203.773 56.8696 199.416 55.8793L207.734 71.3273C212.883 63.2072 222.112 48.1553 217.834 52.9085Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 186.344,
    cy: 107.851,
    rx: 39.2143,
    ry: 55.8506,
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.05,
    cy: 87.6493,
    rx: 14.8539,
    ry: 14.2597,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.599,
    cy: 87.6493,
    r: 14.2597,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.94156,
    transform: "matrix(1 0 0 -1 172.084 82.8961)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.97078,
    transform: "matrix(1 0 0 -1 173.867 79.9253)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.94156,
    transform: "matrix(1 0 0 -1 201.792 82.8961)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 187.122,
    cy: 99.5324,
    rx: 4.15909,
    ry: 5.94156,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 168.703,
    cy: 161.325,
    rx: 2.37662,
    ry: 5.94156,
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 172.268,
    cy: 162.513,
    rx: 2.37662,
    ry: 5.94156,
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.833,
    cy: 162.513,
    rx: 2.37662,
    ry: 5.94156,
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.37662,
    ry: 5.94156,
    transform: "matrix(-1 0 0 1 203.164 162.513)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.37662,
    ry: 5.94156,
    transform: "matrix(-1 0 0 1 199.599 163.701)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.37662,
    ry: 5.94156,
    transform: "matrix(-1 0 0 1 196.034 163.701)",
    fill: "#955A24"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.97078,
    transform: "matrix(1 0 0 -1 204.763 79.9253)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.673 119.229C166.762 133.758 159.053 146.888 158.009 147.038C155.919 147.338 145.87 136.761 143.781 122.232C141.693 107.702 144.677 95.2519 150.446 94.4226C156.215 93.5934 162.585 104.699 164.673 119.229Z",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.327 119.898C208.238 134.428 215.947 147.557 216.991 147.707C219.081 148.008 229.13 137.431 231.219 122.901C233.307 108.372 230.323 95.9216 224.554 95.0924C218.785 94.2631 212.415 105.369 210.327 119.898Z",
    fill: "#434343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 198,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgler);
export default __webpack_public_path__ + "static/media/ugler.429611a46f25ab14586e3939b6cc9421.svg";
export { ForwardRef as ReactComponent };